module.exports = __webpack_public_path__ + "static/media/97.9aef194b.png";